import React from 'react';
import { X, Check, XCircle, CheckCircle2 } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function AntesDespues() {
  const revealRef = useScrollReveal();
  return <section id="antes-despues" className="bg-negro py-14 sm:py-[90px] px-6" data-id="element-15">
      <div ref={revealRef} className="max-w-[1060px] mx-auto reveal" data-id="element-16">
        <div className="text-center" data-id="element-17">
          <span className="text-[11px] tracking-[5px] uppercase text-oro mb-4 block" data-id="element-18">
            La transformación real
          </span>
          <h2 className="font-playfair text-[clamp(28px,4.5vw,52px)] font-bold leading-[1.15] mb-6" data-id="element-19">
            Antes y después de
            <br data-id="element-20" />
            <em className="italic text-oro-claro" data-id="element-21">El Método Italiano™</em>
          </h2>
          <div className="w-[60px] h-[2px] bg-gradient-to-r from-oro to-transparent mx-auto my-5" data-id="element-22"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-0 mt-14 items-stretch" data-id="element-23">
          <div className="p-10 rounded-md bg-[#1a0a0a] border border-rojo-acento/30" data-id="element-24">
            <h3 className="font-montserrat text-[14px] font-black tracking-[3px] uppercase mb-7 text-[#e74c3c] flex items-center gap-2" data-id="element-25">
              <X size={18} data-id="element-26" /> Antes
            </h3>
            <div className="flex items-start gap-3 mb-4.5 text-[14px] leading-[1.6] text-white/80" data-id="element-27">
              <XCircle className="text-[#e74c3c] mt-0.5 shrink-0" size={14} data-id="element-28" />
              <span data-id="element-29">Pasta que se deshace al mezclar con la salsa</span>
            </div>
            <div className="flex items-start gap-3 mb-4.5 text-[14px] leading-[1.6] text-white/80" data-id="element-30">
              <XCircle className="text-[#e74c3c] mt-0.5 shrink-0" size={14} data-id="element-31" />
              <span data-id="element-32">Sabor artificial que delata el "sin gluten"</span>
            </div>
            <div className="flex items-start gap-3 mb-4.5 text-[14px] leading-[1.6] text-white/80" data-id="element-33">
              <XCircle className="text-[#e74c3c] mt-0.5 shrink-0" size={14} data-id="element-34" />
              <span data-id="element-35">Textura gomosa o harinosa según el día</span>
            </div>
            <div className="flex items-start gap-3 mb-4.5 text-[14px] leading-[1.6] text-white/80" data-id="element-36">
              <XCircle className="text-[#e74c3c] mt-0.5 shrink-0" size={14} data-id="element-37" />
              <span data-id="element-38">Gastar $8–15 por paquete con resultado incierto</span>
            </div>
            <div className="flex items-start gap-3 mb-4.5 text-[14px] leading-[1.6] text-white/80" data-id="element-39">
              <XCircle className="text-[#e74c3c] mt-0.5 shrink-0" size={14} data-id="element-40" />
              <span data-id="element-41">Vergüenza al servir a amigos o familia</span>
            </div>
            <div className="flex items-start gap-3 mb-4.5 text-[14px] leading-[1.6] text-white/80" data-id="element-42">
              <XCircle className="text-[#e74c3c] mt-0.5 shrink-0" size={14} data-id="element-43" />
              <span data-id="element-44">Buscar eternamente la marca "que funcione"</span>
            </div>
          </div>

          <div className="hidden md:flex items-center justify-center px-5" data-id="element-45">
            <div className="w-14 h-14 rounded-full bg-oro text-negro font-montserrat font-black text-[13px] flex items-center justify-center" data-id="element-46">
              VS
            </div>
          </div>

          <div className="p-10 rounded-md bg-[#0a1a0a] border border-verde/30 mt-6 md:mt-0" data-id="element-47">
            <h3 className="font-montserrat text-[14px] font-black tracking-[3px] uppercase mb-7 text-verde flex items-center gap-2" data-id="element-48">
              <Check size={18} data-id="element-49" /> Después
            </h3>
            <div className="flex items-start gap-3 mb-4.5 text-[14px] leading-[1.6] text-white/80" data-id="element-50">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-51" />
              <span data-id="element-52">
                Pasta firme que aguanta cualquier salsa, al dente real
              </span>
            </div>
            <div className="flex items-start gap-3 mb-4.5 text-[14px] leading-[1.6] text-white/80" data-id="element-53">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-54" />
              <span data-id="element-55">Sabor auténtico que nadie identifica como alternativa</span>
            </div>
            <div className="flex items-start gap-3 mb-4.5 text-[14px] leading-[1.6] text-white/80" data-id="element-56">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-57" />
              <span data-id="element-58">Textura consistente en cada preparación</span>
            </div>
            <div className="flex items-start gap-3 mb-4.5 text-[14px] leading-[1.6] text-white/80" data-id="element-59">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-60" />
              <span data-id="element-61">Costo por plato reducido más del 60%</span>
            </div>
            <div className="flex items-start gap-3 mb-4.5 text-[14px] leading-[1.6] text-white/80" data-id="element-62">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-63" />
              <span data-id="element-64">Orgullo de cocinar y compartir en la mesa</span>
            </div>
            <div className="flex items-start gap-3 mb-4.5 text-[14px] leading-[1.6] text-white/80" data-id="element-65">
              <CheckCircle2 className="text-verde mt-0.5 shrink-0" size={14} data-id="element-66" />
              <span data-id="element-67">Un sistema replicable, no experimentos</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}